import React, { ReactElement } from 'react'

import { NavLinkData } from '@mindfulchefuk/features/Navigation/interfaces'
import { useSignedOutNavMobileContext } from '@mindfulchefuk/features/Navigation/components/Header/SignedOutNav/context/SignedOutNavMobileContext'
import { NavItem } from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { SignedOutNavMobileItems } from '@mindfulchefuk/features/Navigation/components/Header/SignedOutNav/SignedOutNavMobile/SignedOutNavMobileItems/SignedOutNavMobileItems'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'

type TSignedOutNavMobileLinkList = {
  links: NavLinkData[]
}

export const SignedOutNavMobileLinkList = ({
  links,
}: TSignedOutNavMobileLinkList): ReactElement => {
  const { handleCloseMobileNav } = useSignedOutNavMobileContext()

  const onLinkClick = (label: string) => {
    trackAnalyticsEvent({
      name: 'nav link clicked',
      data: {
        'link name': label,
        section: 'top nav',
        'page source': 'homepage',
      },
    })
    handleCloseMobileNav()
  }

  return (
    <>
      {links.map((link) => {
        if (link.subNav) {
          return <SignedOutNavMobileItems link={link} />
        }

        return (
          <NavItem
            {...link}
            key={link.id}
            href={link.href}
            hasSubMenu={false}
            icon={link.icon}
            onClick={() => onLinkClick(link.label)}
          >
            {link.label}
          </NavItem>
        )
      })}
    </>
  )
}
